export const PORTAL_SHOW    = Symbol.for('portal.show');
export const PORTAL_HIDE    = Symbol.for('portal.hide');
export const TOGGLE_SIDEBAR = Symbol.for('sidebar.show');
export const SMART_SET      = Symbol.for('smart.set');
export const SMART_UPDATE   = Symbol.for('smart.update');